<template>
<div class="answer-options">
  <v-card-title class="answer-options__title ma-0 pa-0">
    <v-row class="ma-0 pa-0">
      <h2 class="ma-0">{{ $t('answerOptions') }}</h2>
    </v-row>
  </v-card-title>
  <v-main class="answer-options__list ma-0 pa-0 mt-5">
    <v-row width="inherit" class="ma-0 pa-0 text-gray font-weight-medium" style="font-size: .7rem;">
        <v-col :cols="canInvert ? 9 : 11" class="ma-0 pa-0">
            {{ $t('answerOptions')}}
        </v-col>
        <v-col v-if="canInvert" cols="2" class="ma-0 text-center pa-0 align-center">
            <div :title="$t('invertedInfo')">inv.&nbsp;</div>
        </v-col>
        <v-col cols="1" class="ma-0 text-center pa-0">
            {{$t('action')}}
        </v-col>
    </v-row>        
    <v-row v-for="(input,k) in choices" :key="k" class="ma-0 pa-0">
        <v-col :cols="canInvert ? 9 : 11" class="ma-0 pa-0">
          <v-text-field v-focus-on-create :label="$t('answerOption')+(k+1)" @keydown.enter="add()" v-model="input.value" />
        </v-col>
        <v-col v-if="canInvert" cols="2" class="actionCol d-flex align-center justify-center">
          <v-checkbox v-model="input.inverted" class="ma-0"></v-checkbox>
        </v-col>
        <v-col cols="1" class="actionCol d-flex align-center">
          <v-icon color="gray" medium @click="remove(k)" class="ma-1">
            mdi-delete
          </v-icon>
        </v-col>
    </v-row>
    <v-row class="ma-0 pa-0">
      <v-btn elevation="0" block @click="add()" large class="ma-0">
        <v-icon color="gray" medium>
          add_circle_outline
        </v-icon>
        &nbsp; <span>Antwortmöglichkeit hinzufügen</span>
      </v-btn>
    </v-row>
</v-main>
</div>
</template>

<script>
import Vue from 'vue'
export default {
  data(){
      return{
      }
  },
  props:{
      choices: Array,
      canInvert: Boolean
  },
  directives: {
    'focus-on-create': {
        // directive definition
        bind: function (el) {
            Vue.nextTick(() => { 
                    el.querySelector('input').focus()
                })
            }
    }
  },
  methods: {
      add(){
          this.choices.push({value: "", inverted: false});
      },
      remove(index){
          this.choices.splice(index, 1);
      }
  },
};
</script>
<style scoped>
.actionCol{
    height:60px;
    text-align-last: center;
    writing-mode: vertical-rl;  
}
</style>